import { Enums } from "@/services/dropdown-enums";

export const isCanceledAppointment = (appointment) => {
  const status = String(appointment?.status ?? "").toLowerCase();
  return (
    appointment?.status === Enums.AppointmentStates.Canceled ||
    appointment?.status === Enums.AppointmentStatuses.Canceled ||
    status === "canceled" ||
    status === "cancelled" ||
    status === "4" ||
    status === "5"
  );
};

export const addColorInServiceType = (serviceTypes = [], colors = []) => {
  // Calculate the number of times colors need to be repeated
  const colorRepeatCount = Math.ceil(
    serviceTypes.length / (colors.length || 1)
  );

  // Create a new array with repeated colors
  const repeatedColors = Array.from(
    { length: colorRepeatCount },
    () => colors
  ).flat();

  // Add colors property to each type object
  const typesWithColors = serviceTypes.map((type, index) => ({
    ...type,
    color: repeatedColors[index % repeatedColors.length],
  }));

  return typesWithColors;
};

export const addColorInEvents = (
  events = [],
  serviceTypes = [],
  key = "serviceTypeId"
) => {
  // Add color property to each event
  const eventsWithColor = events.map((event) => {
    if (event.isBusy) {
      return event;
    }
    return {
      ...event,
      color: serviceTypes.find((service) => service[key] === event[key])?.color || event.color,
    };
  });
  return eventsWithColor;
};
